import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import Tools from './views/Tools.vue'
import Errors from './views/Errors.vue'
import Monitoring from './views/Monitoring'
import URLSChecker from "@/views/tools/URLSChecker";
import Compare from "@/views/tools/Compare";
import Home from "@/views/tools/Home";
import AccessLogs from "@/views/AccessLogs"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/tools',
      name: 'tools',
      component: Tools,
      children:[
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'urls',
          name: 'URLSChecker',
          component: URLSChecker
        },
        {
          path: 'compare',
          name: 'compare',
          component: Compare
        }
      ]
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors
    },
    {
      path: '/monitoring',
      name: 'monitoring',
      component: Monitoring
    },
    {
      path: '/access-logs',
      name: 'access-logs',
      component: AccessLogs
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(/* webpackChunkName: "about" */ './views/About.vue')
      }
    }
  ]
})
